module.exports = __webpack_public_path__ + "img/icon-soundon.6c81ae1.svg";